import React from 'react';
import i18next from '../../../locale/initI18';
import {
  Dialog,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';

import './SelectLanguage.scss';

type SelectLanguageProps = {
  open: boolean;
  onClose: () => void;
};

export const SelectLanguage: React.FC<SelectLanguageProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  const [value, setValue] = React.useState(i18next.language);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  const handleSubmit = () => {
    i18next.changeLanguage(value);
    window.localStorage.setItem('language', value);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="select-language"
      PaperProps={{
        style: {
          padding: 0,
          minWidth: 300,
        },
      }}
    >
      <DialogActions className="dialog-actions d-flex justify-content-between w-100">
        <DialogTitle className="p-1" color="inherit">
          {t('menu_language')}
        </DialogTitle>
        <IconButton className="close-btn" onClick={onClose}>
          <Close color="inherit" />
        </IconButton>
      </DialogActions>
      <FormControl className="p-4">
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="en"
          name="radio-buttons-group"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            name="English"
            value="en"
            control={<Radio />}
            label="English"
          />
          <FormControlLabel
            name="Hindi"
            value="hi"
            control={<Radio />}
            label="Hindi"
          />
          <FormControlLabel
            name="Hinglish"
            value="hien"
            control={<Radio />}
            label="Hinglish"
          />
        </RadioGroup>
      </FormControl>
      <Button className="mx-3 my-3" variant="contained" onClick={handleSubmit}>
        {t('btn_ok')}
      </Button>
    </Dialog>
  );
};
